import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./Afiliaciones.css";
import {
  FiSearch,
  FiEye,
  FiRefreshCw,
  FiUpload,
  FiDownload,
  FiFeather,
  FiXCircle,
  FiUsers,
  FiGrid,
  FiCheckCircle,
  FiClock,
  FiSlash
} from "react-icons/fi";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import PageTitle from "../components/PageTitle";

const API = process.env.REACT_APP_API_URL;

const STATUS_LABELS = {
  submitted: "Registrado",
  pdf_ready: "PDF listo",
  sent_to_sign: "En firma",
  signed: "Firmado",
  rejected: "Cancelado",
  expired: "Vencido",
};

const FIXED_STATUSES = [
  "sent_to_sign",
  "signed",
  "expired",
  "rejected"
];


function Afiliaciones() {
  /* ===================== STATE ===================== */
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [summary, setSummary] = useState({});

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    estadoFondo: "",
    fromDate: "",
    toDate: "",
  });

  const [page, setPage] = useState(1);
  const limit = 20;

  const [openDetail, setOpenDetail] = useState(false);
  const [detail, setDetail] = useState(null);
  const [, setLoadingDetail] = useState(false);
  const [bulkFrom, setBulkFrom] = useState("");
  const [bulkTo, setBulkTo] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkResult, setBulkResult] = useState(null);
  const [showControlAfiliaciones, setShowControlAfiliaciones] = useState(false);
  const [controlDesde, setControlDesde] = useState("");
  const [controlHasta, setControlHasta] = useState("");
  const [generarAsociados, setGenerarAsociados] = useState(false);
  const [generarAhorros, setGenerarAhorros] = useState(false);
  const [controlSummary, setControlSummary] = useState(null);
  const [uploadingEmployees, setUploadingEmployees] = useState(false);
  const [uploading102, setUploading102] = useState(false);
  const [uploadingTerminations, setUploadingTerminations] = useState(false);
  const [inconsistencias, setInconsistencias] = useState([]);
  const [showInconsistencias, setShowInconsistencias] = useState(false);
  const [availableEstadoFondo, setAvailableEstadoFondo] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [detalleSearch, setDetalleSearch] = useState("");
  const [loadingMessage, setLoadingMessage] = useState("");
  const [procesandoReporte, setProcesandoReporte] = useState(false);
  const token = localStorage.getItem("token");
  const [showActualizaciones, setShowActualizaciones] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState("");
  const [updatesLoading, setUpdatesLoading] = useState(false);
  const [showSignatureManager, setShowSignatureManager] = useState(false);

  const [updatesData, setUpdatesData] = useState({
    totals: {},
    updates: {
      salary: [],
      contract: [],
      civilStatus: [],
      bank: []
    },
    warnings: []
  });

  const [activeUpdateTab, setActiveUpdateTab] = useState("salary");


  /* ===================== LOAD ===================== */
  const load = async () => {

    try {

      const params = {
        page,
        limit,
        ...filters,
      };

      const res = await axios.get(
        `${API}/api/admin/affiliations`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setItems(res.data.data);

      setTotal(res.data.total);

    } catch (error) {

      if (
        error.response?.status === 401 ||
        error.response?.status === 403
      ) {
        return;
      }

      console.error(
        "Error cargando afiliaciones",
        error
      );

    }

  };

  const loadSummary = async () => {

    try {

      const res = await axios.get(
        `${API}/api/admin/affiliations/summary`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSummary(
        res.data.summary || {}
      );

    } catch (error) {

      if (
        error.response?.status === 401 ||
        error.response?.status === 403
      ) {
        return;
      }

      console.error(
        "Error loadSummary",
        error
      );

    }

  };

  const loadEstadoFondo = async () => {

    try {

      const res = await axios.get(
        `${API}/api/admin/affiliations/filters`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setAvailableEstadoFondo(
        res.data.availableEstadoFondo || []
      );

    } catch (error) {

      if (
        error.response?.status === 401 ||
        error.response?.status === 403
      ) {
        return;
      }

      console.error(
        "Error loadEstadoFondo",
        error
      );

    }

  };

  useEffect(() => {
    load();
  }, [filters, page]);

  useEffect(() => {

    loadSummary();

    loadEstadoFondo();

  }, []);

  const pages = useMemo(
    () => Math.ceil(total / limit),
    [total, limit]
  );

  /* ===================== STATUS CHIP ===================== */
  const statusChip = (status) => {
    const map = {
      submitted: { label: "Registrado", cls: "inv-chip-yellow" },
      pdf_ready: { label: "PDF listo", cls: "inv-chip-blue" },
      sent_to_sign: { label: "En firma", cls: "inv-chip-gray" },
      signed: { label: "Firmado", cls: "inv-chip-green" },
      rejected: { label: "Cancelado", cls: "inv-chip-red" },
      expired: { label: "Vencido", cls: "inv-chip-red" }
    };

    const s = map[status] || { label: status, cls: "inv-chip-gray" };
    return <span className={`inv-chip ${s.cls}`}>{s.label}</span>;
  };

  /* ===================== MODAL ===================== */
  const openModal = async (id) => {
    try {
      setLoadingDetail(true);
      setOpenDetail(true);

      const res = await axios.get(
        `${API}/api/admin/affiliations/${id}/detail`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setDetail(res.data.data);
    } finally {
      setLoadingDetail(false);
    }
  };

  /* ===================== EXPORT EXCEL ===================== */
  const exportExcel = () => {
    const params = new URLSearchParams(filters).toString();
    window.open(
      `${API}/api/admin/affiliations/export/excel?${params}`,
      "_blank"
    );
  };

  const [confirm, setConfirm] = useState(null);
  const [validating, setValidating] = useState(false);
  const [validationResult, setValidationResult] = useState(null);


  const handleReenviar = async () => {
    try {
      await axios.post(`${API}/api/admin/affiliations/${confirm.item._id}/reenviar`);
      toast.success("Notificación reenviada ✅");
      setConfirm(null);
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error reenviando notificación");
    }
  };


  const handleCancelar = async () => {
    await axios.post(
      `${API}/api/admin/affiliations/${confirm.item._id}/cancelar`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setConfirm(null);
    load(); // refresca tabla
  };

  const handleValidateSignatures = async () => {
    try {
      setValidating(true);
      setValidationResult(null);

      const res = await axios.post(
        `${API}/api/admin/affiliations/validate-signatures`
      );

      setValidationResult(res.data);

      await load();
      await loadSummary();

    } catch (err) {
      console.error(
        "Error validando firmas afiliaciones",
        err
      );

      setValidationResult({
        error: true
      });

    } finally {
      setValidating(false);
    }
  };

  /* ================= FILTROS DESDE RESUMEN ================= */

  const formatDate = (date) => {

    const year =
      date.getFullYear();

    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, "0");

    const day =
      String(
        date.getDate()
      ).padStart(2, "0");

    return `${year}-${month}-${day}`;

  };

  const getDateRangeByKey = (key) => {

    const today = new Date();

    switch (key) {

      case "today": {

        const date =
          formatDate(today);

        return {
          fromDate: date,
          toDate: date
        };

      }

      case "yesterday": {

        const yesterday =
          new Date(today);

        yesterday.setDate(
          yesterday.getDate() - 1
        );

        const date =
          formatDate(yesterday);

        return {
          fromDate: date,
          toDate: date
        };

      }

      case "thisMonth": {

        const start =
          new Date(
            today.getFullYear(),
            today.getMonth(),
            1
          );

        return {
          fromDate:
            formatDate(start),

          toDate:
            formatDate(today)
        };

      }

      case "lastMonth": {

        const start =
          new Date(
            today.getFullYear(),
            today.getMonth() - 1,
            1
          );

        const end =
          new Date(
            today.getFullYear(),
            today.getMonth(),
            0
          );

        return {
          fromDate:
            formatDate(start),

          toDate:
            formatDate(end)
        };

      }

      case "thisYear": {

        const start =
          new Date(
            today.getFullYear(),
            0,
            1
          );

        return {
          fromDate:
            formatDate(start),

          toDate:
            formatDate(today)
        };

      }

      default:

        return {
          fromDate: "",
          toDate: ""
        };

    }

  };

  const filterAll = (key) => {

    setFilters({
      search: "",
      status: "",
      estadoFondo: "",
      ...getDateRangeByKey(key)
    });

    setPage(1);

  };

  const filterByStatus = (key, status) => {

    setFilters({
      search: "",
      status,
      estadoFondo: "",
      ...getDateRangeByKey(key)
    });

    setPage(1);

  };

  const handleReenviarMasivo = async () => {
    if (!bulkFrom || !bulkTo) {
      toast.warn("Selecciona fecha desde y hasta.");
      return;
    }

    try {
      setBulkLoading(true);
      setBulkResult(null);

      const res = await axios.post(
        `${API}/api/admin/affiliations/reenviar-masivo`,
        { fromDate: bulkFrom, toDate: bulkTo }
      );

      setBulkResult(res.data);

      toast.success(
        `Listo ✅ Reenviadas: ${res.data.resent} | Errores: ${res.data.errors}`
      );

      load(); // refresca tabla si quieres
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Error reenviando masivo");
      setBulkResult({ error: true });
    } finally {
      setBulkLoading(false);
    }
  };

  const handleValidarFirmaItem = async (it) => {
    try {
      if (!it?.enviafirma?.documentoId) {
        toast.warn("Esta afiliación no tiene documentoId de firma.");
        return;
      }

      toast.info("Validando estado de firma...");

      // 👇 ESTE ES EL ENDPOINT QUE YA TIENES
      const res = await axios.get(
        `${API}/api/admin/affiliations/${it._id}/detail`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const updated = res.data.data;

      const ef = updated?.enviafirma?.rawResponse || updated?.enviafirma?.raw || updated?.enviafirma?.webhookPayload || {};
      const estado = ef?.estado || "—";
      toast.success(`Actualización de firma realizada`);

      // refresca tabla
      load();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Error validando firma");
    }
  };

  const pctChange = (current, previous) => {
    const c = Number(current || 0);
    const p = Number(previous || 0);

    if (p === 0) {
      if (c === 0) return { pct: 0, dir: "flat" };
      return { pct: 100, dir: "up" }; // si antes era 0 y ahora hay, muestro 100%
    }

    const raw = ((c - p) / p) * 100;
    const pct = Math.round(Math.abs(raw));
    const dir = raw > 0 ? "up" : raw < 0 ? "down" : "flat";
    return { pct, dir };
  };

  const Delta = ({ current, previous }) => {
    const { pct, dir } = pctChange(current, previous);
    if (dir === "flat") return null;

    return (
      <span className={`inv-delta ${dir}`}>
        <span className="inv-delta-tri">
          {dir === "up" ? "▲" : "▼"}
        </span>
        <span>{pct}%</span>
      </span>
    );
  };

  const toTitleCase = (text = "") => {

    const minusculas = [
      "de",
      "del",
      "la",
      "las",
      "el",
      "los",
      "y",
      "e",
      "o",
      "u",
      "en",
      "a",
      "al",
      "por",
      "para",
      "con"
    ];

    return text
      .toLowerCase()
      .split(" ")
      .map((word, index) => {

        if (
          index > 0 &&
          minusculas.includes(word)
        ) {
          return word;
        }

        return (
          word.charAt(0).toUpperCase() +
          word.slice(1)
        );

      })
      .join(" ");
  };

  const loadControlSummary =
    async () => {

      const res = await axios.get(
        `${API}/api/admin/affiliations/control/summary`
      );

      setControlSummary(res.data);

    };

  const handleImportEmployees = async (e) => {

    const file = e.target.files?.[0];

    if (!file) return;

    setUploadingEmployees(true);

    try {

      const formData = new FormData();
      formData.append("file", file);

      await axios.post(
        `${API}/api/admin/affiliations/import-employee-active`,
        formData
      );

      toast.success(
        "Base de empleados actualizada"
      );

      await loadControlSummary();

    } catch (error) {
      const respuesta =
        error.response?.data;

      console.error(
        "Error importando archivo:",
        respuesta || error
      );

      toast.error(
        `${respuesta?.message ||
        respuesta?.error ||
        "No fue posible importar el archivo"}`
      );
    } finally {

      setUploadingEmployees(false);

      e.target.value = "";

    }

  };

  const handleImportReport102 = async (e) => {

    const file = e.target.files?.[0];

    if (!file) return;

    setUploading102(true);

    try {

      const formData = new FormData();

      formData.append("file", file);

      await axios.post(
        `${API}/api/admin/affiliations/import-report102`,
        formData
      );

      toast.success(
        "Reporte 102 actualizado"
      );

      await loadControlSummary();

      load();

    } catch (error) {
      const respuesta =
        error.response?.data;

      console.error(
        "Error importando archivo:",
        respuesta || error
      );

      toast.error(
        `${respuesta?.message ||
        respuesta?.error ||
        "No fue posible importar el archivo"}`
      );
    } finally {

      setUploading102(false);

      e.target.value = "";

    }

  };

  const handleImportTerminations = async (e) => {

    const file =
      e.target.files?.[0];

    if (!file) return;

    const formData =
      new FormData();

    formData.append(
      "file",
      file
    );

    try {

      setUploadingTerminations(
        true
      );

      await axios.post(

        `${API}/api/admin/affiliations/import-employee-termination`,

        formData,

        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }

      );

      toast.success(
        "Base de Bajas importada correctamente"
      );

      loadSummary();

    } catch (error) {
      const respuesta =
        error.response?.data;

      console.error(
        "Error importando archivo:",
        respuesta || error
      );

      toast.error(
        `${respuesta?.message ||
        respuesta?.error ||
        "No fue posible importar el archivo"}`
      );
    } finally {

      setUploadingTerminations(
        false
      );

      e.target.value = "";

    }

  };

  const [previewData, setPreviewData] = useState({

    firmadas: 0,
    cumplen: 0,
    errores: 0,
    yaAsociados: 0,
    empleadosBaja: 0,
    duplicados: 0,
    sinContrato: 0,
    reingresos: 0,
    revision: 0,

  });

  const [previewGenerada, setPreviewGenerada] = useState(false);
  const [generandoPreview, setGenerandoPreview] = useState(false);
  const [descargandoArchivo, setDescargandoArchivo] = useState(false);

  const esCargaHoy = (fecha) => {
    if (!fecha) return false;

    const hoy = new Date();
    const f = new Date(fecha);

    return (
      hoy.getFullYear() === f.getFullYear() &&
      hoy.getMonth() === f.getMonth() &&
      hoy.getDate() === f.getDate()
    );
  };

  const fechaCorta = (fecha) => {
    if (!fecha) return "Sin carga";

    return new Date(fecha).toLocaleDateString("es-CO");
  };

  const generarVistaPreviaAfiliaciones = async () => {
    if (!controlDesde || !controlHasta) {
      return toast.warn("Selecciona fecha desde y hasta.");
    }

    if (!generarAsociados && !generarAhorros) {
      return toast.warn("Selecciona al menos un reporte a generar.");
    }

    try {
      setGenerandoPreview(true);
      setPreviewGenerada(false);

      const { data } = await axios.post(
        `${API}/api/admin/affiliations/generate-preview`,
        {
          desde: controlDesde,
          hasta: controlHasta,
          generarAsociados,
          generarAhorros,
        }
      );

      setPreviewData({
        firmadas: data.firmadas || 0,
        cumplen: data.cumplen || 0,
        errores: data.errores || 0,
        yaAsociados: data.yaAsociados || 0,
        duplicados: data.duplicados || 0,
        empleadosBaja: data.empleadosBaja || 0,
        sinContrato: data.sinContrato || 0,
        reingresos: data.reingresos || 0,
        revision: data.revision || 0,
      });

      setInconsistencias([
        ...(data.detalleReporte || []),
        ...(data.registrosRevision || [])
      ]);

      setPreviewGenerada(true);

      toast.success("Reporte generado con exito.");
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.message ||
        "Error generando reporte."
      );
    } finally {
      setGenerandoPreview(false);
    }
  };

  const mensajesProceso = [
    "Validando afiliaciones...",
    "Verificando asociados activos...",
    "Consultando empleados activos...",
    "Analizando reingresos...",
    "Generando estructura ERP...",
    "Creando archivos...",
    "Puliendo últimos detalles..."
  ];

  const descargarArchivoAfiliaciones = async () => {

    setProcesandoReporte(true);

    let current = 0;

    setLoadingMessage(
      mensajesProceso[0]
    );

    const interval = setInterval(() => {

      current =
        (current + 1) %
        mensajesProceso.length;

      setLoadingMessage(
        mensajesProceso[current]
      );

    }, 1800);

    if (!previewGenerada) {
      return toast.warn(
        "Primero debes generar el reporte."
      );
    }

    try {

      setDescargandoArchivo(true);

      // ==========================
      // AFILIACIONES
      // ==========================

      if (generarAsociados) {

        const response =
          await axios.post(

            `${API}/api/admin/affiliations/generate-file`,

            {
              desde: controlDesde,
              hasta: controlHasta
            },

            {
              responseType: "blob"
            }

          );

        const blob =
          new Blob(

            [response.data],

            {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }

          );

        const url =
          window.URL.createObjectURL(
            blob
          );

        const link =
          document.createElement("a");

        link.href = url;

        link.download =
          `AfiliacionesERP_${controlDesde}_${controlHasta}.xlsx`;

        document.body.appendChild(
          link
        );

        link.click();

        link.remove();

        window.URL.revokeObjectURL(
          url
        );

      }

      // ==========================
      // AHORROS START PEOPLE
      // ==========================

      if (generarAhorros) {

        const responseStart =
          await axios.post(

            `${API}/api/admin/affiliations/generate-savings-startpeople`,

            {
              desde: controlDesde,
              hasta: controlHasta
            },

            {
              responseType: "blob"
            }

          );

        const blobStart =
          new Blob(

            [responseStart.data],

            {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }

          );

        const urlStart =
          window.URL.createObjectURL(
            blobStart
          );

        const linkStart =
          document.createElement("a");

        linkStart.href =
          urlStart;

        linkStart.download =
          `AhorrosStartPeople_${controlDesde}_${controlHasta}.xlsx`;

        document.body.appendChild(
          linkStart
        );

        linkStart.click();

        linkStart.remove();

        window.URL.revokeObjectURL(
          urlStart
        );

        // ==========================
        // AHORROS CRM
        // ==========================

        const responseCRM =
          await axios.post(

            `${API}/api/admin/affiliations/generate-savings-crm`,

            {
              desde: controlDesde,
              hasta: controlHasta
            },

            {
              responseType: "blob"
            }

          );

        const blobCRM =
          new Blob(

            [responseCRM.data],

            {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }

          );

        const urlCRM =
          window.URL.createObjectURL(
            blobCRM
          );

        const linkCRM =
          document.createElement("a");

        linkCRM.href =
          urlCRM;

        linkCRM.download =
          `AhorrosCRM_${controlDesde}_${controlHasta}.xlsx`;

        document.body.appendChild(
          linkCRM
        );

        linkCRM.click();

        linkCRM.remove();

        window.URL.revokeObjectURL(
          urlCRM
        );

      }

      toast.success(
        "Reporte descargado correctamente."
      );

    } catch (err) {

      console.error(err);

      toast.error(
        "Error descargando reporte."
      );

    } finally {

      setDescargandoArchivo(false);

      clearInterval(interval);

      setProcesandoReporte(false);

    }

  };

  useEffect(() => {

    const timeout = setTimeout(() => {

      setFilters((prev) => ({
        ...prev,
        search: searchInput
      }));

      setPage(1);

    }, 300);

    return () => clearTimeout(timeout);

  }, [searchInput]);

  const detalleReporteFiltrado = [...inconsistencias]
    .filter((item) => {
      const query = detalleSearch
        .toLowerCase()
        .trim();

      if (!query) return true;

      return (
        String(item.radicado || "")
          .toLowerCase()
          .includes(query) ||
        String(item.documento || "")
          .toLowerCase()
          .includes(query) ||
        String(item.nombre || "")
          .toLowerCase()
          .includes(query) ||
        String(item.empresaContratante || "")
          .toLowerCase()
          .includes(query) ||
        String(item.motivo || "")
          .toLowerCase()
          .includes(query)
      );
    })
    .sort((a, b) =>
      String(a.motivo || "").localeCompare(
        String(b.motivo || "")
      )
    );

  const exportarDetalleReporte = () => {
    if (!detalleReporteFiltrado.length) {
      return toast.warn("No hay registros para exportar.");
    }

    const data = detalleReporteFiltrado.map((item) => ({
      Radicado: item.radicado || "",
      Identificacion: item.documento || "",
      Nombre: item.nombre || "",
      Empresa: item.empresaContratante || "",
      Motivo: item.motivo || "",
      Fecha: item.fecha
        ? new Date(item.fecha).toLocaleString("es-CO")
        : ""
    }));

    const worksheet =
      XLSX.utils.json_to_sheet(data);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Detalle Reporte"
    );

    XLSX.writeFile(
      workbook,
      `detalle_reporte_${controlDesde}_a_${controlHasta}.xlsx`
    );
  };

  const porcentajeAprobacion =
    previewData?.firmadas > 0
      ? Math.round(
        (previewData.cumplen /
          previewData.firmadas) *
        100
      )
      : 0;

  const [porcentajeAnimado, setPorcentajeAnimado] = useState(0);

  useEffect(() => {

    if (!previewGenerada) return;

    setPorcentajeAnimado(0);

    let actual = 0;

    const objetivo =
      Number(porcentajeAprobacion) || 0;

    const timer = setInterval(() => {

      actual++;

      setPorcentajeAnimado(actual);

      if (actual >= objetivo) {
        clearInterval(timer);
      }

    }, 20);

    return () =>
      clearInterval(timer);

  }, [
    porcentajeAprobacion,
    previewGenerada
  ]);

  const loadUpdatesPreview = async () => {
    try {

      setUpdatesLoading(true);

      const { data } = await axios.get(
        `${API}/api/admin/affiliations/updates/preview`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setUpdatesData(data);

    } catch (err) {

      console.error(err);

      toast.error(
        err.response?.data?.message ||
        "Error generando actualizaciones"
      );

    } finally {

      setUpdatesLoading(false);

    }
  };

  const downloadUpdateFile = async (type) => {
    try {
      setDownloadingFile(type);

      const response = await axios.get(
        `${API}/api/admin/affiliations/updates/download/${type}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const blob = new Blob(
        [response.data],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
      );

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;

      const names = {
        salary: "Actualizacion_Salario.xlsx",
        contract: "Actualizacion_Contrato.xlsx",
        "civil-status": "Actualizacion_EstadoCivil.xlsx",
        bank: "Actualizacion_Bancaria.xlsx"
      };

      link.download =
        names[type] ||
        "actualizacion.xlsx";

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);

      toast.success("Archivo descargado correctamente");

    } catch (err) {

      console.error(err);

      toast.error(
        "Error descargando archivo"
      );

    } finally {

      setDownloadingFile("");

    }
  };

  const currentUpdates =
    updatesData?.updates?.[
    activeUpdateTab
    ] || [];

  const formatNumber = (value) => {
    return Number(value || 0)
      .toLocaleString("es-CO");
  };

  const formatMoney = (value) => {
    return Number(value || 0)
      .toLocaleString("es-CO");
  };

  const titleCase = (text = "") => {

    return text
      .toLowerCase()
      .split(" ")
      .map(
        word =>
          word.charAt(0)
            .toUpperCase() +
          word.slice(1)
      )
      .join(" ");

  };

  const getContractLabel = (
    value
  ) => {

    if (
      value === "TI"
    ) {
      return "Término Indefinido";
    }

    if (
      value === "CO"
    ) {
      return "Culminación de Obra";
    }

    return value;

  };

  const getCivilStatusLabel = (
    value
  ) => {

    const map = {
      C: "Casado",
      S: "Soltero",
      D: "Divorciado",
      V: "Viudo",
      U: "Unión Libre",
      E: "Separado"
    };

    return map[value] || value;

  };

  const hoy = new Date();

  const anioActual =
    hoy.getFullYear();

  const nombreMesActual =
    hoy.toLocaleString("es-CO", {
      month: "long"
    });

  const fechaMesAnterior =
    new Date(
      hoy.getFullYear(),
      hoy.getMonth() - 1,
      1
    );

  const nombreMesAnterior =
    fechaMesAnterior.toLocaleString(
      "es-CO",
      {
        month: "long"
      }
    );

  return (

    <>

      <PageTitle title="Afiliaciones" />

      <div className="inv-root">
        {/* ================= HEADER ================= */}
        <header className="inv-header">
          <h2 className="inv-title">| Afiliaciones</h2>

          <div className="inv-actions">

            <button
              className="af-btn-secondary inv-btn-excel"
              onClick={exportExcel}
            >
              <FiDownload size={15} /> Exportar Excel
            </button>

            <button
              className="af-btn-primary"
              onClick={() => {
                setShowControlAfiliaciones(true);
                loadControlSummary();
              }}
            >
              <FiGrid size={15} />
              Hub de afiliaciones
            </button>

            <button
              className="af-btn-primary"
              onClick={async () => {

                setShowActualizaciones(true);

                const hasData =
                  updatesData?.generatedAt;

                if (!hasData) {
                  await loadUpdatesPreview();
                }

              }}
            >
              <FiRefreshCw />
              Actualizaciones
            </button>

            <button
              className="af-btn-primary"
              onClick={() =>
                setShowSignatureManager(true)
              }
            >
              <FiFeather size={15} /> Gestión de firmas
            </button>

            <button
              className="af-btn-primary"
              onClick={() => window.open("/afiliacion", "_blank")}
            >
              <FiUsers size={15} /> Nueva afiliación
            </button>

          </div>
        </header>

        {/* ================= RESUMEN ================= */}
        <div className="inv-summary">
          {[
            {
              key: "thisYear",
              label: (
                <>
                  Recibidas durante el <strong>{anioActual}</strong>
                </>
              )
            },
            {
              key: "lastMonth",
              label: (
                <>
                  Recibidas en <strong>{nombreMesAnterior}</strong>
                </>
              )
            },
            {
              key: "thisMonth",
              label: (
                <>
                  Recibidas en <strong>{nombreMesActual}</strong>
                </>
              )
            },
            {
              key: "yesterday",
              label: (
                <>
                  Recibidas <strong>ayer</strong>
                </>
              )
            },
            {
              key: "today",
              label: (
                <>
                  Recibidas <strong>hoy</strong>
                </>
              )
            },
          ].map(({ key, label }, idx) => (
            <React.Fragment key={key}>
              <div className="inv-summary-block">

                <p className="inv-summary-label">
                  {label}
                </p>

                <div className="inv-summary-value">

                  <h2
                    className="clickable"
                    onClick={() => filterAll(key)}
                  >
                    {(summary[key]?.total || 0).toLocaleString("es-CO")}
                  </h2>

                  {key === "thisMonth" && (
                    <Delta
                      current={summary.thisMonth?.total}
                      previous={summary.lastMonth?.total}
                    />
                  )}

                  {key === "today" && (
                    <Delta
                      current={summary.today?.total}
                      previous={summary.yesterday?.total}
                    />
                  )}

                </div>

                <div className="inv-summary-statuses">

                  <span
                    className="status-item signed"
                    title="Firmadas"
                    onClick={() =>
                      filterByStatus(key, "signed")
                    }
                  >
                    <FiCheckCircle />
                    <b>
                      {(summary[key]?.signed || 0).toLocaleString("es-CO")}
                    </b>
                  </span>

                  <span className="status-separator">|</span>

                  <span
                    className="status-item pending"
                    title="En firma"
                    onClick={() =>
                      filterByStatus(key, "sent_to_sign")
                    }
                  >
                    <FiFeather />
                    <b>
                      {(summary[key]?.pending || 0).toLocaleString("es-CO")}
                    </b>
                  </span>

                  <span className="status-separator">|</span>

                  <span
                    className="status-item cancelled"
                    title="Canceladas"
                    onClick={() =>
                      filterByStatus(key, "rejected")
                    }
                  >
                    <FiSlash />
                    <b>
                      {(summary[key]?.cancelled || 0).toLocaleString("es-CO")}
                    </b>
                  </span>

                  <span className="status-separator">|</span>

                  <span
                    className="status-item expired"
                    title="Vencidas"
                    onClick={() =>
                      filterByStatus(key, "expired")
                    }
                  >
                    <FiClock />
                    <b>
                      {(summary[key]?.expired || 0).toLocaleString("es-CO")}
                    </b>
                  </span>

                </div>

              </div>

              {idx < 4 && <div className="inv-summary-divider" />}
            </React.Fragment>
          ))}
        </div>

        {/* ================= FILTROS ================= */}
        <div className="inv-filters">
          <div className="inv-row">

            {/* 🔍 Buscador */}
            <div className="afil-field">
              <FiSearch />
              <input
                placeholder="Buscar por nombre, documento o radicado…"
                value={searchInput}
                onChange={(e) =>
                  setSearchInput(e.target.value)
                }
              />
            </div>

            {/* 📌 Estado */}
            <select
              className="inv-select"
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
            >
              <option value="">Estado firma</option>

              {FIXED_STATUSES.map((s) => (
                <option key={s} value={s}>
                  {STATUS_LABELS[s] || s}
                </option>
              ))}
            </select>

            <select
              className="inv-select"
              value={filters.estadoFondo}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  estadoFondo: e.target.value,
                });
                setPage(1);
              }}
            >
              <option value="">
                Estado Fondo
              </option>

              {availableEstadoFondo.map((estado) => (
                <option
                  key={estado}
                  value={estado}
                >
                  {estado}
                </option>
              ))}
            </select>

            {/* 📅 Fecha desde */}
            <div className="inv-date-field">
              <input
                type="date"
                value={filters.fromDate}
                onChange={(e) =>
                  setFilters({ ...filters, fromDate: e.target.value })
                }
              />
            </div>

            {/* 📅 Fecha hasta */}
            <div className="inv-date-field">
              <input
                type="date"
                value={filters.toDate}
                onChange={(e) =>
                  setFilters({ ...filters, toDate: e.target.value })
                }
              />
            </div>

            {/* 🔄 Restablecer */}
            <button
              className="inv-btn-ghost"
              onClick={() => {

                setSearchInput("");

                setFilters({
                  search: "",
                  status: "",
                  estadoFondo: "",
                  fromDate: "",
                  toDate: "",
                });

                setPage(1);

              }}
            >
              Restablecer
            </button>
          </div>
        </div>


        {/* ================= TABLA ================= */}
        <div className="inv-table">
          <table>
            <thead>
              <tr>
                <th>Radicado</th>
                <th>Fecha Recibido</th>
                <th>Identificación</th>
                <th>Nombre</th>
                <th>Empresa</th>
                <th>Ciudad</th>
                <th>Estado Fondo</th>
                <th>Estado Firma</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {items.map((it) => (
                <tr key={it._id}>
                  <td>{it.radicado}</td>
                  <td>{new Date(it.createdAt).toLocaleDateString("es-CO")}</td>
                  <td>{it.numeroDocumento}</td>
                  <td>{toTitleCase(it.nombres)}</td>
                  <td>{it.empresaContratante || "-"}</td>
                  <td>
                    {(toTitleCase(it.municipio || "-").length > 20)
                      ? toTitleCase(it.municipio || "-").slice(0, 20) + "..."
                      : toTitleCase(it.municipio || "-")}
                  </td>
                  <td>{it.estadoFondo || "No Asociado"}</td>
                  <td>{statusChip(it.status)}</td>
                  <td className="inv-actions-row">
                    <button
                      className="inv-icon-btn"
                      onClick={() => openModal(it._id)}
                      title="Ver detalle"
                    >
                      <FiEye />
                    </button>

                    {it?.enviafirma?.documentoId && (
                      <button
                        className="inv-icon-btn"
                        title={
                          it.status === "sent_to_sign"
                            ? "Validar firma"
                            : "Solo disponible en estado 'Enviado a firma'"
                        }
                        onClick={() => handleValidarFirmaItem(it)}
                        disabled={it.status !== "sent_to_sign"}
                      >
                        <FiFeather />
                      </button>
                    )}

                    <button
                      className="inv-icon-btn"
                      title={
                        it.status === "sent_to_sign"
                          ? "Reenviar firma"
                          : "Solo disponible en estado 'Enviado a firma'"
                      }
                      onClick={() =>
                        setConfirm({
                          type: "reenviar",
                          item: it,
                        })
                      }
                      disabled={it.status !== "sent_to_sign"}
                    >
                      <FiRefreshCw />
                    </button>

                    <button
                      className="inv-icon-btn"
                      title={
                        it.status === "sent_to_sign"
                          ? "Cancelar firma"
                          : "Proceso no cancelable"
                      }
                      disabled={it.status !== "sent_to_sign"}
                      onClick={() =>
                        setConfirm({
                          type: "cancelar",
                          item: it,
                        })
                      }
                    >
                      <FiXCircle />
                    </button>
                  </td>
                </tr>
              ))}

              {items.length === 0 && (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    Cargando datos...
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* ================= PAGINACIÓN ================= */}
          <div className="inv-paginacion">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Anterior
            </button>

            <span className="inv-pagina-info">
              Página {page} de {pages}
            </span>

            <button
              disabled={page === pages}
              onClick={() => setPage(page + 1)}
            >
              Siguiente
            </button>
          </div>
        </div>

        {openDetail && detail && (
          <div className="afd-overlay">

            <div className="afd-modal">

              {/* ================= HEADER ================= */}

              <div className="afd-header">

                <div>

                  <div className="afd-status">

                    {detail.enviafirma?.rawResponse?.estado === "firmado"
                      ? "Documento Firmado"
                      : detail.enviafirma?.rawResponse?.estado === "rechazado"
                        ? "Rechazado"
                        : detail.enviafirma?.rawResponse?.estado === "cancelado"
                          ? "Cancelado"
                          : "Pendiente"}

                  </div>

                  <h2>
                    {detail.nombres}
                  </h2>

                  <span>
                    Radicado #{detail.radicado}
                  </span>

                </div>

                <button
                  className="afd-close"
                  onClick={() => setOpenDetail(false)}
                  aria-label="Cerrar"
                >
                  ✕
                </button>

              </div>


              {/* ================= BODY ================= */}

              <div className="afd-body">


                {/* ================= AFILIADO ================= */}

                <div className="afd-section">

                  <h3>
                    Información del Afiliado
                  </h3>

                  <div className="afd-grid">

                    <div className="afd-card">
                      <label>Documento</label>
                      <span>
                        {detail.numeroDocumento || "—"}
                      </span>
                    </div>

                    <div className="afd-card">
                      <label>Email</label>
                      <span>
                        {detail.email || "—"}
                      </span>
                    </div>

                    <div className="afd-card">
                      <label>Celular</label>
                      <span>
                        {detail.celular || "—"}
                      </span>
                    </div>

                    <div className="afd-card">
                      <label>Ciudad</label>
                      <span>
                        {detail.ciudad || "—"}
                      </span>
                    </div>

                    <div className="afd-card">
                      <label>Estado Local</label>
                      <span>
                        {detail.status || "—"}
                      </span>
                    </div>

                    <div className="afd-card">
                      <label>Fecha Registro</label>

                      <span>
                        {detail.createdAt
                          ? new Date(
                            detail.createdAt
                          ).toLocaleString("es-CO")
                          : "—"}
                      </span>

                    </div>

                  </div>

                </div>


                {/* ================= FIRMA ================= */}

                {(() => {

                  const ef =
                    detail.enviafirma?.rawResponse ||
                    {};

                  const firmantes =
                    ef.firmantes || [];

                  return (
                    <>


                      {/* ================= INFORMACIÓN FIRMA ================= */}

                      <div className="afd-section">

                        <h3>
                          Firma Electrónica
                        </h3>

                        <div className="afd-grid">

                          <div className="afd-card">

                            <label>
                              ID Documento
                            </label>

                            <span>
                              {ef.id ||
                                detail.enviafirma?.documentoId ||
                                "—"}
                            </span>

                          </div>


                          <div className="afd-card">

                            <label>
                              Estado Nexafirma
                            </label>

                            <span>
                              {ef.estado || "—"}
                            </span>

                          </div>


                          <div className="afd-card">

                            <label>
                              Nombre Documento
                            </label>

                            <span>
                              {ef.nombreDocumento || "—"}
                            </span>

                          </div>


                          <div className="afd-card">

                            <label>
                              Método
                            </label>

                            <span>
                              {ef.metodoNotificacion || "—"}
                            </span>

                          </div>


                          <div className="afd-card">

                            <label>
                              Idioma
                            </label>

                            <span>
                              {ef.idiomaNotificaciones || "—"}
                            </span>

                          </div>


                          <div className="afd-card">

                            <label>
                              Fecha Firma
                            </label>

                            <span>
                              {ef.fechaCompletado
                                ? new Date(
                                  ef.fechaCompletado
                                ).toLocaleString("es-CO")
                                : "Pendiente"}
                            </span>

                          </div>

                        </div>


                        {/* ================= HASH ================= */}

                        {ef.hashSha256 && (

                          <div className="afd-hash">

                            <small>
                              HASH SHA256
                            </small>

                            <code>
                              {ef.hashSha256}
                            </code>

                          </div>

                        )}

                      </div>


                      {/* ================= FIRMANTES ================= */}

                      {firmantes.length > 0 && (

                        <div className="afd-section">

                          <h3>
                            Firmantes
                          </h3>

                          <div className="afd-signers">

                            {firmantes.map(
                              (firmante, idx) => (

                                <div
                                  key={idx}
                                  className="afd-signer"
                                >

                                  <div>

                                    <strong>
                                      {firmante.nombre}
                                    </strong>

                                    <span>
                                      {firmante.email ||
                                        firmante.numeroCelular}
                                    </span>

                                  </div>


                                  <div>

                                    <strong>
                                      {firmante.estado}
                                    </strong>

                                    <span>

                                      {firmante.fechaFirmado
                                        ? new Date(
                                          firmante.fechaFirmado
                                        ).toLocaleString(
                                          "es-CO"
                                        )
                                        : "Sin firma"}

                                    </span>

                                  </div>

                                </div>

                              )
                            )}

                          </div>

                        </div>

                      )}


                      {/* ================= DOCUMENTOS ================= */}

                      <div className="afd-section">

                        <h3>
                          Documentos
                        </h3>

                        <div className="afd-actions">

                          {/* 
                    Si existe documento firmado,
                    mostrar únicamente el firmado.
                  */}

                          {ef.rutaDocumentoFirmado && (
                            <a
                              href={ef.rutaDocumentoFirmado}
                              target="_blank"
                              rel="noreferrer"
                              className="af-btn-primary"
                            >
                              Ver afiliación firmada
                            </a>
                          )}


                          {/* 
                    Si NO existe documento firmado,
                    mostrar el documento enviado.
                  */}

                          {!ef.rutaDocumentoFirmado &&
                            ef.rutaDocumentoOriginal && (
                              <a
                                href={ef.rutaDocumentoOriginal}
                                target="_blank"
                                rel="noreferrer"
                                className="inv-btn af-btn-primary"
                              >
                                Ver documento enviado
                              </a>
                            )}

                        </div>

                      </div>

                    </>
                  );

                })()}

              </div>

            </div>

          </div>
        )}

        {confirm && (
          <div className="inv-modal-overlay">
            <div className="inv-confirm-modal">
              <h3>
                {confirm.type === "reenviar"
                  ? "Reenviar Notificación"
                  : "Cancelar Proceso"}
              </h3>

              <p>
                {confirm.type === "reenviar"
                  ? "¿Deseas reenviar la notificación de firma al empleado?"
                  : "Esta acción cancelará el proceso de firma."}
              </p>

              <div className="inv-modal-actions">
                <button
                  className="af-btn-secondary"
                  onClick={() => setConfirm(null)}
                >
                  Cancelar
                </button>

                {confirm.type === "reenviar" ? (
                  <button
                    className="af-btn-primary"
                    onClick={handleReenviar}
                  >
                    Reenviar
                  </button>
                ) : (
                  <button
                    className="af-btn-primary"
                    onClick={handleCancelar}
                  >
                    Confirmar
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {showControlAfiliaciones && (
          <div
            className="signature-modal-overlay"
            onClick={() => setShowControlAfiliaciones(false)}
          >
            <div
              className="afc-modal"
              onClick={(e) => e.stopPropagation()}
            >

              {/* HEADER */}

              <div className="afc-header">

                <button
                  className="afc-close-btn"
                  onClick={() => setShowControlAfiliaciones(false)}
                  title="Cerrar"
                >
                  ✕
                </button>

                <h2>
                  Hub de Afiliaciones
                </h2>

                <p>
                  Gestión y generación de archivos para crear nuevos asociados
                </p>

              </div>

              {/* KPIS */}

              <div className="afc-kpis-grid">

                <div className="afc-kpi">

                  <span>Empleados activos</span>

                  <strong>
                    {controlSummary?.empleadosActivos?.toLocaleString("es-CO") || "0"}
                  </strong>

                  <small>
                    {controlSummary?.empleadosImport?.date
                      ? `Histórico al día ${fechaCorta(controlSummary.empleadosImport.date)}`
                      : "Sin carga"}
                  </small>

                </div>

                <div className="afc-kpi">

                  <span>Reporte 102</span>

                  <strong>
                    {controlSummary?.totalReporte102?.toLocaleString("es-CO") || "0"}
                  </strong>

                  <small>
                    {controlSummary?.reporte102Import?.date
                      ? `Histórico al día ${fechaCorta(controlSummary.reporte102Import.date)}`
                      : "Sin carga"}
                  </small>

                </div>

                <div className="afc-kpi">

                  <span>Asociados</span>

                  <strong>
                    {controlSummary?.asociados?.toLocaleString("es-CO") || "0"}
                  </strong>

                  <small>
                    Activos en el Fondo
                  </small>

                </div>

                <div className="afc-kpi">

                  <span>No Asociados</span>

                  <strong>
                    {controlSummary?.noAsociados?.toLocaleString("es-CO") || "0"}
                  </strong>

                  <small>
                    Pendientes de afiliación
                  </small>

                </div>

              </div>

              {/* FUENTES */}

              <div className="afc-section">

                <div className="afc-section-title">

                  <h3>
                    Fuentes de información
                  </h3>

                </div>

                <div className="afc-grid">

                  {/* EMPLEADOS ACTIVOS */}

                  <div className="afc-card">

                    <div className="afc-source-head">

                      <div>

                        <h4>
                          Empleados Activos
                        </h4>

                        <p>
                          Información actual de colaboradores
                        </p>

                      </div>

                      <span
                        className={`afc-badge ${esCargaHoy(controlSummary?.empleadosImport?.date)
                          ? "ok"
                          : "warning"
                          }`}
                      >
                        {esCargaHoy(controlSummary?.empleadosImport?.date)
                          ? "Actualizado"
                          : "Pendiente"}
                      </span>

                    </div>

                    <div className="afc-source-inline">

                      <div className="afc-inline-item">
                        <span>Última carga</span>
                        <strong>
                          {controlSummary?.empleadosImport?.date
                            ? new Date(
                              controlSummary.empleadosImport.date
                            ).toLocaleString("es-CO")
                            : "Sin información"}
                        </strong>
                      </div>

                      <div className="afc-inline-divider" />

                      <div className="afc-inline-item">
                        <span>Registros</span>
                        <strong>
                          {(
                            controlSummary?.empleadosActivos || 0
                          ).toLocaleString("es-CO")}
                        </strong>
                      </div>

                      <div className="afc-inline-divider" />

                      <button
                        className="af-btn-secondary"
                        disabled={uploadingEmployees}
                        onClick={() =>
                          document
                            .getElementById(
                              "employees-file-input"
                            )
                            ?.click()
                        }
                      >

                        <FiUpload size={15} />

                        {uploadingEmployees
                          ? "Importando..."
                          : "Importar"}

                      </button>

                      <input
                        id="employees-file-input"
                        type="file"
                        accept=".xlsx"
                        style={{ display: "none" }}
                        onChange={handleImportEmployees}
                      />

                    </div>

                  </div>

                  {/* REPORTE 102 */}

                  <div className="afc-card">

                    <div className="afc-source-head">

                      <div>

                        <h4>
                          Reporte 102
                        </h4>

                        <p>
                          Historial de asociados
                        </p>

                      </div>

                      <span
                        className={`afc-badge ${esCargaHoy(controlSummary?.reporte102Import?.date)
                          ? "ok"
                          : "warning"
                          }`}
                      >
                        {esCargaHoy(controlSummary?.reporte102Import?.date)
                          ? "Actualizado"
                          : "Pendiente"}
                      </span>

                    </div>

                    <div className="afc-source-inline">

                      <div className="afc-inline-item">
                        <span>Última carga</span>
                        <strong>
                          {controlSummary?.reporte102Import?.date
                            ? new Date(
                              controlSummary.reporte102Import.date
                            ).toLocaleString("es-CO")
                            : "Sin información"}
                        </strong>
                      </div>

                      <div className="afc-inline-divider" />

                      <div className="afc-inline-item">
                        <span>Registros</span>
                        <strong>
                          {(
                            controlSummary?.totalReporte102 || 0
                          ).toLocaleString("es-CO")}
                        </strong>
                      </div>

                      <div className="afc-inline-divider" />

                      <button
                        className="af-btn-secondary"
                        disabled={uploading102}
                        onClick={() =>
                          document
                            .getElementById(
                              "report102-file-input"
                            )
                            ?.click()
                        }
                      >
                        <FiUpload size={15} />

                        {uploading102
                          ? "Importando..."
                          : "Importar"}

                      </button>

                      <input
                        id="report102-file-input"
                        type="file"
                        accept=".xlsx"
                        style={{ display: "none" }}
                        onChange={handleImportReport102}
                      />

                    </div>

                  </div>

                  {/* BAJAS */}

                  <div className="afc-card">

                    <div className="afc-source-head">

                      <div>

                        <h4>
                          Bajas
                        </h4>

                        <p>
                          Empleados próximos a retiro
                        </p>

                      </div>

                      <span
                        className={`afc-badge ${esCargaHoy(
                          controlSummary?.terminationImport?.date
                        )
                          ? "ok"
                          : "warning"
                          }`}
                      >

                        {esCargaHoy(
                          controlSummary?.terminationImport?.date
                        )
                          ? "Actualizado"
                          : "Pendiente"}

                      </span>

                    </div>

                    <div className="afc-source-inline">

                      <div className="afc-inline-item">

                        <span>
                          Última carga
                        </span>

                        <strong>

                          {controlSummary?.terminationImport?.date

                            ? new Date(
                              controlSummary
                                .terminationImport
                                .date
                            ).toLocaleString(
                              "es-CO"
                            )

                            : "Sin información"}

                        </strong>

                      </div>

                      <div className="afc-inline-divider" />

                      <div className="afc-inline-item">

                        <span>
                          Registros
                        </span>

                        <strong>

                          {(
                            controlSummary?.totalTerminations ||
                            0
                          ).toLocaleString(
                            "es-CO"
                          )}

                        </strong>

                      </div>

                      <div className="afc-inline-divider" />

                      <button
                        className="af-btn-secondary"
                        disabled={uploadingTerminations}
                        onClick={() =>
                          document
                            .getElementById(
                              "termination-file-input"
                            )
                            ?.click()
                        }
                      >

                        <FiUpload size={15} />

                        {uploadingTerminations

                          ? "Importando..."

                          : "Importar"}

                      </button>

                      <input
                        id="termination-file-input"
                        type="file"
                        accept=".xlsx"
                        style={{
                          display: "none"
                        }}
                        onChange={
                          handleImportTerminations
                        }
                      />

                    </div>

                  </div>

                </div>

              </div>

              {/* GENERACIÓN */}

              <div className="afc-section">

                <div className="afc-section-title">

                  <h3>
                    Generación de reporte
                  </h3>

                </div>

                <div className="afc-card">

                  <div className="afc-generator-line">

                    <div className="afc-field">

                      <label>
                        Fecha desde
                      </label>

                      <input
                        type="date"
                        value={controlDesde}
                        onChange={(e) => {
                          setControlDesde(e.target.value);
                          setPreviewGenerada(false);
                        }}
                      />

                    </div>

                    <div className="afc-field">

                      <label>
                        Fecha hasta
                      </label>

                      <input
                        type="date"
                        value={controlHasta}
                        onChange={(e) => {
                          setControlHasta(e.target.value);
                          setPreviewGenerada(false);
                        }}
                      />

                    </div>

                    <div className="afc-checks afc-checks-inline">

                      <label>

                        <input
                          type="checkbox"
                          checked={generarAsociados}
                          onChange={(e) => {
                            setGenerarAsociados(e.target.checked);
                            setPreviewGenerada(false);
                          }}
                        />

                        Reporte afiliaciones

                      </label>

                      <label>

                        <input
                          type="checkbox"
                          checked={generarAhorros}
                          onChange={(e) => {
                            setGenerarAhorros(e.target.checked);
                            setPreviewGenerada(false);
                          }}
                        />

                        Reporte ahorros

                      </label>

                    </div>

                    <div className="afc-field afc-field-button">
                      <label>&nbsp;</label>

                      <div style={{ display: "flex", gap: 10 }}>

                        <button
                          className="afcc-btn-primary"
                          onClick={generarVistaPreviaAfiliaciones}
                          disabled={generandoPreview}
                        >
                          {generandoPreview
                            ? "Generando..."
                            : "Generar reporte"}
                        </button>

                        <button
                          className="inv-btn-ghost"
                          onClick={() => {

                            setControlDesde("");
                            setControlHasta("");

                            setGenerarAsociados(false);
                            setGenerarAhorros(false);

                            setPreviewGenerada(false);

                            setPreviewData({
                              firmadas: 0,
                              cumplen: 0,
                              errores: 0,
                              yaAsociados: 0,
                              duplicados: 0,
                              empleadosBaja: 0,
                              sinContrato: 0,
                              reingresos: 0,
                              revision: 0
                            });

                            setInconsistencias([]);

                          }}
                        >
                          Restablecer
                        </button>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              {previewGenerada && (
                <>

                  {/* PREVIA */}

                  <div className="afc-report-card">

                    <div className="afc-report-donut-section">

                      <div
                        className="afc-report-donut"
                        style={{
                          background: `conic-gradient(
                     #333 ${porcentajeAnimado}%,
                     #e5e7eb ${porcentajeAnimado}%
                   )`
                        }}
                      >

                        <div className="afc-report-donut-center">

                          <strong>
                            {porcentajeAnimado}%
                          </strong>


                          <span>
                            Cumplen Condiciones
                          </span>

                        </div>

                      </div>

                      <p className="afc-report-donut-text">

                        De las <strong>{(previewData?.firmadas || 0).toLocaleString("es-CO")}</strong> afiliaciones
                        encontradas, <strong>{(previewData?.cumplen || 0).toLocaleString("es-CO")}</strong> cumplen
                        todas las validaciones y pueden continuar al proceso de afiliación.

                      </p>

                    </div>

                    <div className="afc-report-divider" />

                    <div className="afc-report-summary">

                      <h4>
                        Resumen del Reporte
                      </h4>

                      <div className="afc-summary-row">
                        <span>Firmadas</span>
                        <strong>{(previewData?.firmadas || 0).toLocaleString("es-CO")}</strong>
                      </div>

                      <div className="afc-summary-row success">
                        <span>Cumplen condiciones</span>
                        <strong>{(previewData?.cumplen || 0).toLocaleString("es-CO")}</strong>
                      </div>

                      <div className="afc-summary-row info">
                        <span>Reingresos (Sujeto a penalidad)</span>
                        <strong>{(previewData?.reingresos || 0).toLocaleString("es-CO")}</strong>
                      </div>

                      <div className="afc-summary-row">
                        <span>Duplicadas</span>
                        <strong>{(previewData?.duplicados || 0).toLocaleString("es-CO")}</strong>
                      </div>

                      <div className="afc-summary-row">
                        <span>Asociados</span>
                        <strong>{(previewData?.yaAsociados || 0).toLocaleString("es-CO")}</strong>
                      </div>

                      <div className="afc-summary-row">
                        <span>Sin contrato</span>
                        <strong>{(previewData?.sinContrato || 0).toLocaleString("es-CO")}</strong>
                      </div>

                      <div className="afc-summary-row">
                        <span>Bajas</span>
                        <strong>{(previewData?.empleadosBaja || 0).toLocaleString("es-CO")}</strong>
                      </div>

                      <div className="afc-summary-row">
                        <span>Requieren revisión</span>
                        <strong>{(previewData?.revision || 0).toLocaleString("es-CO")}</strong>
                      </div>

                    </div>

                  </div>

                  {/* ACCIONES */}

                  <div className="g360-actions">

                    <button
                      className="inv-btn-ghost"
                      disabled={
                        !previewGenerada ||
                        inconsistencias.length === 0
                      }
                      onClick={() =>
                        setShowInconsistencias(true)
                      }
                    >
                      Ver detalle
                    </button>

                    <button
                      className="af-btn-primary"
                      disabled={!previewGenerada || descargandoArchivo}
                      onClick={descargarArchivoAfiliaciones}
                    >
                      {descargandoArchivo
                        ? "Descargando..."
                        : "Descargar reporte"}
                    </button>

                  </div>
                </>
              )}

            </div>
          </div>
        )}

        {showInconsistencias && (

          <div
            className="signature-modal-overlay-II"
            onClick={() =>
              setShowInconsistencias(false)
            }
          >

            <div
              className="afc-modal"
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              <div className="afc-header">

                <div>

                  <h2>
                    Detalles del Reporte
                  </h2>

                  <p>
                    Explora el detalle de los registros generados durante el proceso
                  </p>

                </div>

                <div className="afc-detail-count">

                  Mostrando{" "}
                  <strong>
                    {detalleReporteFiltrado.length.toLocaleString("es-CO")}
                  </strong>{" "}
                  de{" "}
                  <strong>
                    {(inconsistencias?.length || 0).toLocaleString("es-CO")}
                  </strong>{" "}
                  registros

                </div>

              </div>

              <div className="afc-detail-toolbar">

                <div className="afc-search-box">

                  <input
                    type="text"
                    value={detalleSearch}
                    onChange={(e) =>
                      setDetalleSearch(e.target.value)
                    }
                    placeholder="Buscar por radicado, identificación, nombre o detalle..."
                  />

                </div>

                <button
                  className="af-btn-secondary"
                  onClick={exportarDetalleReporte}
                  disabled={!detalleReporteFiltrado.length}
                >
                  Exportar Excel
                </button>

              </div>

              <div className="afc-table-wrapper">

                <table className="g360-table">

                  <thead>

                    <tr>
                      <th>Radicado</th>
                      <th>Identificación</th>
                      <th>Nombre</th>
                      <th>Empresa</th>
                      <th>Detalle</th>
                    </tr>

                  </thead>

                  <tbody>

                    {detalleReporteFiltrado.length > 0 ? (

                      detalleReporteFiltrado.map((i, idx) => (

                        <tr key={idx}>

                          <td>
                            {i.radicado || "—"}
                          </td>

                          <td>
                            {i.documento || "—"}
                          </td>

                          <td>
                            {i.nombre || "—"}
                          </td>

                          <td>
                            {i.empresaContratante || "—"}
                          </td>

                          <td>

                            <span
                              className={`${i.motivo === "Cumple reglas"
                                ? "success"
                                : i.motivo?.includes("Reingreso")
                                  ? "info"
                                  : "warning"
                                }`}
                            >
                              {i.motivo || "—"}
                            </span>

                          </td>

                        </tr>

                      ))

                    ) : (

                      <tr>

                        <td colSpan="4">
                          No se encontraron registros con ese criterio.
                        </td>

                      </tr>

                    )}

                  </tbody>

                </table>

              </div>

              <div className="g360-actions">

                <button
                  className="inv-btn-ghost"
                  onClick={() =>
                    setShowInconsistencias(false)
                  }
                >
                  Cerrar
                </button>

              </div>

            </div>

          </div>

        )}

        {procesandoReporte && (

          <div className="signature-modal-overlay">

            <div className="afc-loading-card">

              <h3>
                Descargando Reporte
              </h3>

              <p>
                {loadingMessage}
              </p>

              <div className="afc-loading-bar">

                <div className="afc-loading-bar-fill" />

              </div>

            </div>

          </div>

        )}

        {showActualizaciones && (
          <div
            className="signature-modal-overlay"
            onClick={() => setShowActualizaciones(false)}
          >
            <div
              className="afc-modal afc-modal-updates"
              onClick={(e) => e.stopPropagation()}
            >

              {/* LOADING OVERLAY */}

              {updatesLoading && (
                <div className="signature-modal-overlay">
                  <div className="afc-loading-card">

                    <h3>
                      Buscando Actualizaciones
                    </h3>

                    <p>
                      Realizando validaciones y consistencia de datos en la información ...
                    </p>

                    <div className="afc-loading-progress">

                      <div className="afc-loading-progress-bar"></div>

                    </div>

                  </div>
                </div>
              )}

              {/* HEADER */}

              <div className="afc-header">

                <button
                  className="afc-close-btn"
                  onClick={() => setShowActualizaciones(false)}
                  title="Cerrar"
                >
                  ✕
                </button>

                <h2>
                  Actualización de Datos
                </h2>

                <p>
                  Generación de reporte para actualización masiva de datos
                </p>

              </div>

              {/* KPIS */}

              <div className="afc-updates-kpis">

                <div className="afc-kpi">
                  <span>Salario</span>
                  <strong>
                    {formatNumber(
                      updatesData?.totals?.salary || 0
                    )}
                  </strong>
                  <small>
                    Cambios detectados
                  </small>
                </div>

                <div className="afc-kpi">
                  <span>Contrato</span>
                  <strong>
                    {formatNumber(
                      updatesData?.totals?.contract || 0
                    )}
                  </strong>
                  <small>
                    Cambios detectados
                  </small>
                </div>

                <div className="afc-kpi">
                  <span>Estado Civil</span>
                  <strong>
                    {formatNumber(
                      updatesData?.totals?.civilStatus || 0
                    )}
                  </strong>
                  <small>
                    Cambios detectados
                  </small>
                </div>

                <div className="afc-kpi">
                  <span>Bancaria</span>
                  <strong>
                    {formatNumber(
                      updatesData?.totals?.bank || 0
                    )}
                  </strong>
                  <small>
                    Cambios detectados
                  </small>
                </div>

              </div>

              {/* ACCIONES */}

              <div className="afc-section">

                <div className="afc-section-title">
                  <h3>
                    Gestión de actualizaciones
                  </h3>
                </div>

                <div className="afc-card">

                  <div
                    className="afc-updates-toolbar"
                    style={{
                      justifyContent: "flex-start"
                    }}
                  >

                    <div className="afc-updates-downloads">

                      <button
                        className="af-btn-secondary"
                        onClick={() =>
                          downloadUpdateFile("salary")
                        }
                        disabled={downloadingFile !== ""}
                      >
                        {downloadingFile === "salary"
                          ? "Descargando..."
                          : "Descargar Salario"}
                      </button>

                      <button
                        className="af-btn-secondary"
                        onClick={() =>
                          downloadUpdateFile("contract")
                        }
                        disabled={downloadingFile !== ""}
                      >
                        {downloadingFile === "contract"
                          ? "Descargando..."
                          : "Descargar Contrato"}
                      </button>

                      <button
                        className="af-btn-secondary"
                        onClick={() =>
                          downloadUpdateFile("civil-status")
                        }
                        disabled={downloadingFile !== ""}
                      >
                        {downloadingFile === "civil-status"
                          ? "Descargando..."
                          : "Descargar Estado Civil"}
                      </button>

                      <button
                        className="af-btn-secondary"
                        onClick={() =>
                          downloadUpdateFile("bank")
                        }
                        disabled={downloadingFile !== ""}
                      >
                        {downloadingFile === "bank"
                          ? "Descargando..."
                          : "Descargar Bancaria"}
                      </button>

                    </div>

                    <button
                      className="afcc-btn-primary"
                      onClick={loadUpdatesPreview}
                      disabled={updatesLoading}
                    >
                      {updatesLoading
                        ? "Buscando..."
                        : "Buscar actualizaciones"}
                    </button>

                  </div>

                </div>

              </div>

              {/* TABS */}

              <div className="afc-section">

                <div className="afc-section-title">
                  <h3>
                    Actualizaciones disponibles
                  </h3>
                </div>

                <div className="afc-card">

                  <div className="afc-updates-tabs">

                    <button
                      className={
                        activeUpdateTab === "salary"
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        setActiveUpdateTab("salary")
                      }
                    >
                      Salario
                    </button>

                    <button
                      className={
                        activeUpdateTab === "contract"
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        setActiveUpdateTab("contract")
                      }
                    >
                      Contrato
                    </button>

                    <button
                      className={
                        activeUpdateTab === "civilStatus"
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        setActiveUpdateTab("civilStatus")
                      }
                    >
                      Estado Civil
                    </button>

                    <button
                      className={
                        activeUpdateTab === "bank"
                          ? "active"
                          : ""
                      }
                      onClick={() =>
                        setActiveUpdateTab("bank")
                      }
                    >
                      Bancaria
                    </button>

                  </div>

                  <div className="afc-updates-table">

                    <table>

                      <thead>

                        <tr>
                          <th>Identificación</th>
                          <th>Nombre</th>
                          <th>Información Actual (CRM)</th>
                          <th>Cambio Sugerido</th>
                        </tr>

                      </thead>

                      <tbody>

                        {currentUpdates.length === 0 ? (

                          <tr>

                            <td
                              colSpan="4"
                              className="afc-empty-cell"
                            >
                              No se encontraron registros
                            </td>

                          </tr>

                        ) : (

                          currentUpdates.map(
                            (item, index) => {

                              let actual = "";
                              let nuevo = "";

                              if (
                                activeUpdateTab === "salary"
                              ) {

                                actual =
                                  `$ ${formatMoney(
                                    item.valorActual102
                                  )}`;

                                nuevo =
                                  `$ ${formatMoney(
                                    item.valorNuevoEmpleadoActivo
                                  )}`;

                              }

                              if (
                                activeUpdateTab === "contract"
                              ) {

                                actual =
                                  `${getContractLabel(
                                    item.tipoContratoActualERP
                                  )} | ${item.fechaContratoActual102 || "-"
                                  }`;

                                nuevo =
                                  `${getContractLabel(
                                    item.tipoContratoNuevoERP
                                  )} | ${item.fechaContratoNueva || "-"
                                  }`;

                              }

                              if (
                                activeUpdateTab === "civilStatus"
                              ) {

                                actual =
                                  getCivilStatusLabel(
                                    item.estadoCivilActualERP
                                  ) || "-";

                                nuevo =
                                  getCivilStatusLabel(
                                    item.estadoCivilNuevoERP
                                  ) || "-";

                              }

                              if (
                                activeUpdateTab === "bank"
                              ) {

                                actual =
                                  `${item.cuentaActual102 || "-"} | Banco ${item.codigoBancoActual102 || "-"
                                  }`;

                                nuevo =
                                  `${item.cuentaNuevaEmpleadoActivo || "-"} | Banco ${item.codigoBancoNuevoERP || "-"
                                  }`;

                              }

                              return (
                                <tr
                                  key={`${item.identificacion}-${index}`}
                                >

                                  <td>
                                    {item.identificacion}
                                  </td>

                                  <td>
                                    {titleCase(
                                      item.nombre102 ||
                                      item.nombreEmpleado ||
                                      "-"
                                    )}
                                  </td>

                                  <td>
                                    {actual}
                                  </td>

                                  <td>
                                    <span className="afc-update-new-value">
                                      {nuevo}
                                    </span>
                                  </td>

                                </tr>
                              );

                            }
                          )

                        )}

                      </tbody>

                    </table>

                  </div>

                </div>

              </div>

              {/* ALERTAS */}

              {updatesData?.warnings?.length > 0 && (

                <div className="afc-section">

                  <div className="afc-update-warning">

                    <strong>
                      Alertas
                    </strong>

                    <p>
                      Existen{" "}
                      {updatesData.warnings.length}
                      {" "}registros del Reporte 102 que no fueron encontrados en Empleados Activos.
                    </p>

                  </div>

                </div>

              )}

            </div>
          </div>
        )}

        {
          showSignatureManager && (

            <div className="signature-modal-overlay">

              <div className="signature-modal">

                {/* HEADER */}

                <div className="signature-modal-header">

                  <h3 className="signature-modal-title">
                    Gestión de Firmas
                  </h3>

                  <button
                    className="signature-modal-close"
                    onClick={() => {
                      setShowSignatureManager(false);
                      setValidationResult(null);
                      setBulkResult(null);
                    }}
                  >
                    ✕
                  </button>

                </div>

                {/* VALIDACION */}

                <div className="signature-card">

                  <div className="signature-card-header">

                    <h4>
                      Validación de Firmas
                    </h4>

                  </div>

                  <p className="signature-card-description">
                    Revisa todas las firmas pendientes y actualiza automáticamente el estado de afiliaciones firmadas.
                  </p>

                  <button
                    className="af-btn-primary"
                    onClick={handleValidateSignatures}
                    disabled={validating}
                  >
                    {
                      validating
                        ? "Validando..."
                        : "Validar Firmas"
                    }
                  </button>

                  {
                    validationResult &&
                    !validationResult.error && (

                      <div className="signature-result">

                        <div>
                          <strong>Revisadas:</strong> {validationResult.checked}
                        </div>

                        <div>
                          <strong>Firmadas:</strong> {validationResult.signed}
                        </div>

                        <div>
                          <strong>Omitidas:</strong> {validationResult.skipped}
                        </div>

                        <div>
                          <strong>Errores:</strong> {validationResult.errors}
                        </div>

                      </div>

                    )
                  }

                  {
                    validationResult?.error && (

                      <div className="signature-error">
                        Error validando firmas.
                      </div>

                    )
                  }

                </div>

                {/* REENVIO */}

                <div className="signature-card">

                  <div className="signature-card-header">

                    <h4>
                      Reenvío Masivo
                    </h4>

                  </div>

                  <p className="signature-card-description">
                    Reenvía notificaciones de firma para afiliaciones dentro de un rango específico de fechas.
                  </p>

                  <div className="signature-date-row">

                    <div>

                      <label>
                        Desde
                      </label>

                      <input
                        type="date"
                        value={bulkFrom}
                        onChange={(e) =>
                          setBulkFrom(
                            e.target.value
                          )
                        }
                        className="inv-date-input"
                      />

                    </div>

                    <div>

                      <label>
                        Hasta
                      </label>

                      <input
                        type="date"
                        value={bulkTo}
                        onChange={(e) =>
                          setBulkTo(
                            e.target.value
                          )
                        }
                        className="inv-date-input"
                      />

                    </div>

                  </div>

                  <button
                    className="af-btn-primary"
                    onClick={handleReenviarMasivo}
                    disabled={
                      bulkLoading ||
                      !bulkFrom ||
                      !bulkTo
                    }
                  >
                    {
                      bulkLoading
                        ? "Reenviando..."
                        : "Reenviar Firmas"
                    }
                  </button>

                  {
                    bulkResult &&
                    !bulkResult.error && (

                      <div className="signature-result">

                        <div>
                          <strong>Encontradas:</strong> {bulkResult.found}
                        </div>

                        <div>
                          <strong>Reenviadas:</strong> {bulkResult.resent}
                        </div>

                        <div>
                          <strong>Omitidas:</strong> {bulkResult.skipped}
                        </div>

                        <div>
                          <strong>Errores:</strong> {bulkResult.errors}
                        </div>

                      </div>

                    )
                  }

                  {
                    bulkResult?.error && (

                      <div className="signature-error">
                        Error ejecutando el reenvío masivo.
                      </div>

                    )
                  }

                </div>

                {/* RESUMEN */}

                <div className="signature-summary">

                  <div className="signature-summary-icon">
                    <FiFeather />
                  </div>

                  <div>

                    <div className="signature-summary-title">
                      Afiliaciones en Proceso
                    </div>

                    <div className="signature-summary-text">

                      Hay {" "}

                      <strong>
                        {(summary?.thisYear?.pending || 0).toLocaleString("es-CO")}
                      </strong>

                      {" "} firmas vigentes pendientes de completar.

                    </div>

                  </div>

                </div>

              </div>

            </div>

          )
        }

      </div>

    </>

  );
}

export default Afiliaciones;
